// NGRX
import { Action } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Update } from '@ngrx/entity';
import { Picking } from '..';

export enum PickingActionTypes {
	PickingOnServerCreated = '[Edit Picking Component] Picking On Server Created',
	PickingCreated = '[Edit Picking Component] Picking Created',
	PickingUpdated = '[Edit Picking Component] Picking Updated',
	PickingStatusUpdated = '[Picking List Page] Picking Status Updated',
	OnePickingDeleted = '[Picking List Page] One Picking Deleted',
	ManyPickingDeleted = '[Picking List Page] Many Selected Picking Deleted',
	PickingPageRequested = '[Picking List Page] Picking Page Requested',
	PickingPageLoaded = '[Picking API] Picking Page Loaded',
	PickingPageCancelled = '[Picking API] Picking Page Cancelled',
	PickingPageToggleLoading = '[Picking] Picking Page Toggle Loading',
	PickingActionToggleLoading = '[Picking] Picking Action Toggle Loading'
}

export class PickingOnServerCreated implements Action {
	readonly type = PickingActionTypes.PickingOnServerCreated;

	constructor(public payload: { Picking: Picking }) {
	}
}

export class PickingCreated implements Action {
	readonly type = PickingActionTypes.PickingCreated;

	constructor(public payload: { Picking: Picking }) {
	}
}

export class PickingUpdated implements Action {
	readonly type = PickingActionTypes.PickingUpdated;

	constructor(public payload: {
		partialPicking: Update<Picking>, // For State update
		Picking: Picking // For Server update (through service)
	}) {
	}
}

export class PickingStatusUpdated implements Action {
	readonly type = PickingActionTypes.PickingStatusUpdated;

	constructor(public payload: {
		Picking: Picking[],
		status: number
	}) {
	}
}

export class OnePickingDeleted implements Action {
	readonly type = PickingActionTypes.OnePickingDeleted;

	constructor(public payload: { id: number }) {
	}
}

export class ManyPickingDeleted implements Action {
	readonly type = PickingActionTypes.ManyPickingDeleted;

	constructor(public payload: { ids: number[] }) {
	}
}

export class PickingPageRequested implements Action {
	readonly type = PickingActionTypes.PickingPageRequested;

	constructor(public payload: { page: QueryParamsModel }) {
	}
}

export class PickingPageLoaded implements Action {
	readonly type = PickingActionTypes.PickingPageLoaded;

	constructor(public payload: { Picking: Picking[], totalCount: number, page: QueryParamsModel }) {
	}
}

export class PickingPageCancelled implements Action {
	readonly type = PickingActionTypes.PickingPageCancelled;
}

export class PickingPageToggleLoading implements Action {
	readonly type = PickingActionTypes.PickingPageToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export class PickingActionToggleLoading implements Action {
	readonly type = PickingActionTypes.PickingActionToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export type PickingActions = PickingOnServerCreated
	| PickingCreated
	| PickingUpdated
	| PickingStatusUpdated
	| OnePickingDeleted
	| ManyPickingDeleted
	| PickingPageRequested
	| PickingPageLoaded
	| PickingPageCancelled
	| PickingPageToggleLoading
	| PickingActionToggleLoading;
